import React, { useEffect, useRef, useState } from 'react';
import Plugin, { PluginProps } from '../Plugin';
import { Helmet } from 'react-helmet';
// import Highlight, { defaultProps } from 'prism-react-renderer';
// import DarkTheme from 'prism-react-renderer/themes/vsDark';
import { Box, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const CodeBlock = (props: PluginProps) => {
  const { content } = props;
  const ref = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    setInterval(() => {
      if (ref.current) {
        (window as any).Prism?.highlightElement(ref.current);
      }
    }, 500);
  }, []);

  const [buttonStyle, setButtonStyle] = useState({
    text: t('plugin.codeBlock.copy'),
    disabled: false,
    opacity: 1,
    colorScheme: 'cyan',
  });

  async function copyToClipboard() {
    await navigator.clipboard.writeText(content.data.code);
  }

  function temporarilyChangeButtonStyle() {
    setButtonStyle({
      text: t('plugin.codeBlock.copied'),
      disabled: true,
      opacity: 0.7,
      colorScheme: 'orange',
    });
    setTimeout(() => {
      setButtonStyle({
        text: t('plugin.codeBlock.copy'),
        disabled: false,
        opacity: 1,
        colorScheme: 'cyan',
      });
    }, 1000);
  }

  return (
    <Box className="code-block" borderRadius={2}>
      <Helmet>
        <link
          type="text/css"
          rel="stylesheet"
          href="/static/syllabus/prism.css"
        />
        <link
          type="text/css"
          rel="stylesheet"
          href="/static/syllabus/prism-theme.css"
        />
        <script type="text/javascript" src="/static/syllabus/prism.js"></script>
      </Helmet>
      <h2>{content.data.title}</h2>

      <div className="preview">
        {content.data.lang !== 'output' && (
          <Button
            pos="absolute"
            top="12px"
            right="12px"
            size="sm"
            zIndex="1"
            color="white"
            disabled={buttonStyle.disabled}
            opacity={buttonStyle.opacity}
            colorScheme={buttonStyle.colorScheme}
            onClick={() => {
              copyToClipboard();
              temporarilyChangeButtonStyle();
            }}
          >
            {buttonStyle.text}
          </Button>
        )}

        <div className="preview">
          <pre
            className={`language-${content.data.lang} ${
              content.data.line_numbers ? 'line-numbers' : ''
            }`}
            data-line={content.data.line_highlight}
          >
            <code ref={ref} className={`language-${content.data.lang}`}>
              {content.data.code}
            </code>
          </pre>
        </div>
        {/* <Highlight
          {...defaultProps}
          // theme={DarkTheme}
          code={content.data.code}
          language={content.data.lang}
          
        >
          {({ className, style, tokens, getLineProps, getTokenProps }) => (
            <pre className={className + (content.data.line_numbers ? ' line-numbers' : '')} data-line={content.data.line_highlight} style={style}>
              {tokens.map((line, i) => (
                <div {...getLineProps({ line, key: i })}>
                  {line.map((token, key) => (
                    <span {...getTokenProps({ token, key })} />
                  ))}
                </div>
              ))}
            </pre>
          )}
        </Highlight> */}
      </div>
    </Box>
  );
};

export default CodeBlock;
